<div class="site-text">
    <p class="text">
        Vous souhaitez systématiser vos échanges de factures électroniques avec vos partenaires commerciaux? Dans le répertoire eDirectory.ch, vous trouverez toutes les entreprises et organisations travaillant avec un prestataire de services rattaché à eDirectory.ch.
    </p>
    <p class="text">
        eDirectory.ch vous accompagne dans votre recherche de partenaires commerciaux domiciliés en Suisse, ainsi que dans l’envoi et/ou la réception d’e-factures.
    </p>
    <p class="text">
        Le répertoire du forum swissDIGIN est géré par PostFinance SA et contribue à une plus grande diffusion de l’échange électronique de factures dans toute la Suisse.
    </p>
</div>